<template>
  <div class="p-3 bg-gray">
    <b class="mr-3">
      Koşul:
    </b>
    <select v-model="selectedRule" class="form-control-sm" style="width: 200px">
      <option disabled value="">{{ $t("system-flow.choose-rule") }}</option>
      <option v-for="rule in rules" :key="rule.identifier" :value="rule.identifier" v-text="rule.name" />
    </select>
    <span
      v-if="selectedRule"
      @click="
        props.addRule(selectedRule);
        selectedRule = null;
      "
      class="ml-2 text-success hand bx-tada  bx"
    >
      <i class="fa fa-check"></i>
      Koşulu Ekle
    </span>

    <span @click="props.newGroup" class="hand float-right">
      <i class="fa fa-plus"> </i>
      Bu koşulun içerisinde yeni bir grup oluştur
    </span>
  </div>
</template>

<script>
export default {
  props: ["props", "when"],
  data() {
    return { selectedRule: undefined };
  },
  computed: {
    rules: {
      get() {
        if (!this.when) {
          return this.props.rules;
        }

        return this.props.rules.filter((p) => p.identifier.startsWith("commons.") || p.displayOnWhen.includes(this.when));
      },
    },
  },
};
</script>

<style scoped>
.bg-gray {
  background-color: #f2f2f2;
}
</style>
